module.exports = __webpack_public_path__ + "static/media/julesSecureMobile.652e50d5.png";